import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const NavigationBarVideoIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 20 20"
    sx={{ width: '20px', height: '20px', ...sx }}
    {...props}
  >
    <path
      d="M15.83 1.67H4.17a2.5 2.5 0 0 0-2.5 2.5v11.66a2.5 2.5 0 0 0 2.5 2.5h11.66a2.5 2.5 0 0 0 2.5-2.5V4.17a2.5 2.5 0 0 0-2.5-2.5Zm-2.42 1.66-3.34 3.34H6.6l3.34-3.34h3.48Zm-10.08.84a.83.83 0 0 1 .84-.84h3.4L4.25 6.67h-.9v-2.5Zm13.34 11.66a.83.83 0 0 1-.84.84H4.17a.83.83 0 0 1-.84-.84v-7.5h13.34v7.5Zm0-9.16h-4.25l3.34-3.34h.07a.83.83 0 0 1 .84.84v2.5Z"
      fill="#5C64ED"
    />
    <path
      d="M15.83 1.67H4.17a2.5 2.5 0 0 0-2.5 2.5v11.66a2.5 2.5 0 0 0 2.5 2.5h11.66a2.5 2.5 0 0 0 2.5-2.5V4.17a2.5 2.5 0 0 0-2.5-2.5Zm-2.42 1.66-3.34 3.34H6.6l3.34-3.34h3.48Zm-10.08.84a.83.83 0 0 1 .84-.84h3.4L4.25 6.67h-.9v-2.5Zm13.34 11.66a.83.83 0 0 1-.84.84H4.17a.83.83 0 0 1-.84-.84v-7.5h13.34v7.5Zm0-9.16h-4.25l3.34-3.34h.07a.83.83 0 0 1 .84.84v2.5Z"
      fill="url(#a)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="10"
        y1="1.67"
        x2="10"
        y2="18.33"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9445EC" />
        <stop offset="1" stopColor="#2782ED" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

NavigationBarVideoIcon.defaultProps = {
  sx: null,
}
